import { render, staticRenderFns } from "./CategoryTags.vue?vue&type=template&id=7614e75f&name=category-tags&"
import script from "./CategoryTags.vue?vue&type=script&lang=js&"
export * from "./CategoryTags.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CategoryTags.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports